import { useContext } from "react";
import { AppContext } from "../App";
import { formatDate } from "../Helpers";
import { MdArrowOutward, MdCall } from "react-icons/md";

export default function One({ data }) {
  const appContext = useContext(AppContext);

  function view() {
    appContext.navTo({
      item: "side-view",
      subItem: "customer-options",
      extraItem: data.uuid,
    });
  }

  return (
    <div className="entity-card" onClick={view}>
      <div className="entity-card-main">
        <div className="entity-card-title-row">
          <h6 className="entity-card-title">{data.fullname}</h6>
        
        </div>

        <div className="entity-card-subtext">
          <span>
            <MdCall size={16} /> {data.phone || "No phone"}
          </span>
          <span>Added {formatDate(data.dateCreated)}</span>
        </div>
      </div>

      <div className="entity-card-end">
        <MdArrowOutward />
      </div>
    </div>
  );
}
